import React, { useContext, useState, useEffect } from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { Context as AuthContext } from '../../context/AuthContext';
import { useHistory, useLocation } from "react-router-dom";

const LoginExtensionPage = () => {
    const { updateSignin, checkAuth } = useContext(AuthContext);
    const [open, setOpen] = useState(true)
    const history = useHistory()
    let location = useLocation();

    useEffect(() => {
        checkUrl();
    }, []);

    const checkUrl = async () => {
        let urlToken = new URL(window.location.href).searchParams.get('token');
        if (urlToken) {
            let { from } = location.state || { from: { pathname: "/" } };
            let signInResp = await updateSignin({token:urlToken});
            if (signInResp === 'success') {
                window.location.replace('/')
            }
            else {
                localStorage.clear()
                checkAuth();
                history.push('/');
            }
                
        }
    }

    return <div>
        <Backdrop open={open} onClick={() => setOpen(false)} style={{ zIndex: 9999, background: '#3a9544',opacity:'0.9' }}>
            <CircularProgress style={{ color: 'white' }} />
        </Backdrop>
    </div>
}

export default LoginExtensionPage;